module.exports = __webpack_public_path__ + "img/sleeve flounce opening.131a6c2d.png";